import $DB from '../../util/debounce'
// eslint-disable-next-line no-unused-vars
import md5 from 'js-md5'
export default {
  data() {
    return {
      user: {
        mobile: '',
        code: '',
        password: '',
        pwd: '',
        sex: '',
        age: '',
        username: '',
      },
      options: [
        {
          value: '1',
          label: '男',
        },
        {
          value: '2',
          label: '女',
        },
      ],
      sex: '',
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      consent: false, //同意
      isAgreement: false, //显示协议
      isPrivacy: false, //保护协议
      agreement: null,
      privacy: null,
    }
  },
  created() {
    this.getAgreement()
  },
  methods: {
    //输入姓名
    changeName(e) {
      if (!e.target.value.match(/^[\u4e00-\u9fa5]+$/)) {
        setTimeout(() => {
          this.user.username = ''
        }, 0)
      }
    },
    //切换性别
    changeSex(e) {
      this.sex = this.options[e - 1].label
      this.user.sex = e
    },
    //是否同意
    changeConsent() {
      this.consent = !this.consent
    },
    //去登陆
    goLogin() {
      this.$router.push('/login')
    },
    //同意
    changecontent() {
      this.isAgreement = false
      this.isPrivacy = false
      this.consent = true
    },
    //取消
    cancel() {
      this.isAgreement = false
      this.isPrivacy = false
    },
    //会员服务条款
    changeAgreement() {
      this.isAgreement = true
      this.isPrivacy = false
    },
    //隐私保护协议
    changePrivacy() {
      this.isAgreement = false
      this.isPrivacy = true
    },
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.user.mobile,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
    //注册页面
    goRegister: $DB(function () {
      if (!this.user.username) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.user.age) {
        this.$message.error('请输入年龄')
        return
      }
      if (!this.user.sex) {
        this.$message.error('请选择性别')
        return
      }
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.user.code) {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.user.password) {
        this.$message.error('请输入密码')
        return
      }
      if (this.user.pwd != this.user.password) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      if (!this.consent) {
        this.$message.error('请先勾选用户同意协议')
        return
      }
      this.$axios
        .post('/api/login/register', {
          mobile: this.user.mobile,
          code: this.user.code,
          password: this.user.password,
          pwd: this.user.pwd,
          type: 2,
          sex: this.user.sex,
          age: this.user.age,
          username: this.user.username,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$router.push('/login')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
            })
          }
        })
    }),
    //获取会员协议
    getAgreement() {
      this.$axios.post('/api/index/service').then((res) => {
        if (res.data.code === 0) {
          this.agreement = res.data.data.desc1
          this.privacy = res.data.data.desc2
        }
      })
    },
  },
}
